<template>
  <div>
    <b-card>
      <b-tabs content-class="mt-3">
        <b-tab title="تراکنش ها" active>
          <list-table
            :fields="fields"
            :url="url"
            :excelroute="true"
            :params="params"
            :btns="btns"
          ></list-table>
          <b-modal id="json-details" hide-footer size="lg">
            <template v-slot:modal-title>جزییات تراکنش</template>
            <b-row>
              <b-col>
                <b-form-group label="بانک مقصد:">
                  <div class="form-control sc-card-pan">
                    {{ transactionDetails.destination_bank }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="مبلغ ریورس مشتریان (ریال):">
                  <div class="form-control sc-card-pan">
                    {{
                      transactionDetails.rcost != null
                        ? transactionDetails.rcost.toLocaleString()
                        : 0
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="کارمزد برگشتی درگاه (ریال):">
                  <div class="form-control sc-card-pan">
                    {{
                      transactionDetails.rkarmozd != null
                        ? transactionDetails.rkarmozd.toLocaleString()
                        : 0
                    }}
                  </div>
                </b-form-group></b-col
              >
            </b-row>
            <b-button class="mt-3" @click="$bvModal.hide('json-details')"
              >بستن</b-button
            >
          </b-modal>
        </b-tab>
        <b-tab title="تسویه ها">
          <list-table
            :url="'inandout?typeofpayment=0'"
            title="گزارش برداشت ها از بانک آینده"
            :fields="fields1"
            :params="params1"
            :excelroute="''"
          ></list-table>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import TableShowData from "@/components/table";
import { GET_USER_LIST } from "@/core/services/store/getUserList.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import _ from "lodash";
import moment from "jalali-moment";

export default {
  name: "AccountersReportTransactions",

  data() {
    return {
      url: "~reports/api/admin-transactions?is_verify=1&mdid12_money_type=483",
      transactionDetails: {},
      fields: [
        {
          key: "id",
          label: "کد تراکنش",
        },
        {
          key: "created_at",
          label: "تاریخ",
          formatter(value, key, item) {
            return moment(value, "YYYY/MM/DDTHH:mm:ss").format(
              "jYYYY/jMM/jDD HH:mm:ss"
            );
          },
        },
        {
          key: "website_name",
          label: "نام وبسایت",
        },
        {
          key: "cost",
          label: "مبلغ واریزی مشتریان (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "shepa_karmozd",
          label: "کارمزد درگاه",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "shaparak_karmozd",
          label: "کارمزد نظام بانکی",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "amount",
          label: "مبلغ پرداختنی درگاه (ریال)",
          formatter(value, key, item) {
            if (item.cost > 0)
              return Number(item.cost - item.shaparak_karmozd).toLocaleString();
            return 0;
          },
        },
        {
          key: "sattled",
          label: "واریزی درگاه (ریال)",
          formatter(value, key, item) {
            if (value < 0) {
              return Number(value).toLocaleString();
            }
            return 0;
          },
        },
        {
          key: "sale_refrence_id",
          label: "کد رهگیری واریز",
        },
        // {
        //   key: "totalsum",
        //   label: "مانده حساب (ریال)",
        // },
        {
          key: "btns",
          label: "جزییات",
        },
      ],
      btns: [
        {
          icon: "eye",
          handler: (t) => {
            const { rcost, rkarmozd, destination_bank } = t;
            this.transactionDetails = { rcost, rkarmozd, destination_bank };
            this.$bvModal.show("json-details");
          },
        },
      ],
      params: [
        {
          label: "از تاریخ:",
          field: "date_from",
          type: "date-picker",
          value: moment().format("jYYYY/jMM/jDD"),
        },
        {
          label: "تا تاریخ:",
          field: "date_to",
          type: "date-picker",
          value: moment().format("jYYYY/jMM/jDD"),
        },
        // {
        //   label: "پذیرنده:",
        //   field: "user_id",
        //   type: "select",
        //   value: null,
        //   options: [],
        // },
        {
          label: "وب سایت:",
          field: "website_name",
          type: "text",
        },
        {
          label: "مبلغ واریزی مشتری (ریال) :",
          field: "cost",
          type: "number",
        },
        // {
        //   label: "مبلغ ریورس مشتریان (ریال) :",
        //   field: "rcost",
        //   type: "number",
        // },
        // {
        //   label: "مبلغ پرداختی درگاه (ریال) :",
        //   field: "amount",
        //   type: "number",
        // },
        // {
        //   label: "مبلغ واریزی درگاه (ریال) :",
        //   field: "sattled",
        //   type: "number",
        // },
      ],
      fields1: [
        {
          key: "name",
          label: "مشتری",
        },
        {
          key: "iban",
          label: "شماره شبا",
        },
        {
          key: "website_name",
          label: "وبسایت مشتری",
          formatter(value, key, item) {
            return item.website_name + " (" + item.website_en_name + ")";
          },
        },
        {
          key: "date",
          label: "تاریخ",
          formatter(value, key, item) {
            return (
              value.substring(0, 4) +
              "/" +
              value.substring(4, 6) +
              "/" +
              value.substring(6, 8)
            );
          },
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "typeofpayment",
          label: "نوع برداشت",
          formatter(value, key, item) {
            var text = "";
            //value == 0 ? "وجه اصلی" : "کارمزد";
            if (value == 0) {
              text = "وجه اصلی";
            }
            if (value == 1) {
              text = "کارمزد";
            }
            if (value == 2) {
              text = "واریز";
            }
            if (value == 4) {
              text = "کارمزد نظام بانکی";
            }
            return text;
          },
        },
        {
          key: "title",
          label: "نام بانک",
          formatter(value, key, item) {
            var newVal = item.iban;
            if (newVal) {
              newVal = newVal.substring(4, 8);
              if (newVal.startsWith("055")) {
                return "بانک اقتصاد نوین";
              } else if (newVal.startsWith("054")) {
                return "بانک پارسیان";
              } else if (newVal.startsWith("057")) {
                return "بانک پاسارگاد";
              } else if (newVal.startsWith("021")) {
                return "پست بانک";
              } else if (newVal.startsWith("018")) {
                return 521;
              } else if (newVal.startsWith("051")) {
                return "موسسه اعتباری توسعه";
              } else if (newVal.startsWith("019")) {
                return "بانک صادرات";
              } else if (newVal.startsWith("013")) {
                return "بانک رفاه کارگران";
              } else if (newVal.startsWith("056")) {
                return "بانک سامان";
              } else if (newVal.startsWith("015")) {
                return "بانک سپه";
              } else if (newVal.startsWith("058")) {
                return "بانک سرمایه";
              } else if (newVal.startsWith("011")) {
                return "بانک صنعت و معدن";
              } else if (newVal.startsWith("053")) {
                return "بانک کارآفرین";
              } else if (newVal.startsWith("016")) {
                return "باک کشاورزی";
              } else if (newVal.startsWith("010")) {
                return "بانک مرکزی";
              } else if (newVal.startsWith("014")) {
                return "بانک مسکن";
              } else if (newVal.startsWith("012")) {
                return "بانک ملت";
              } else if (newVal.startsWith("017")) {
                return "بانک ملی";
              } else if (newVal.startsWith("070")) {
                return "بانک رسالت";
              } else if (newVal.startsWith("063")) {
                return "بانک انصار";
              } else if (newVal.startsWith("061")) {
                return "بانک شهر";
              } else if (newVal.startsWith("052")) {
                return "بانک قوامین";
              } else if (newVal.startsWith("069")) {
                return "بانک ایران زمین";
              } else if (newVal.startsWith("062")) {
                return "بانک آینده";
              } else if (newVal.startsWith("022")) {
                return "بانک توسعه تعاون";
              } else if (newVal.startsWith("065")) {
                return "بانک حکمت ایرانیان";
              } else if (newVal.startsWith("066")) {
                return "بانک دی";
              } else if (newVal.startsWith("059")) {
                return "بانک سینا";
              } else if (newVal.startsWith("060")) {
                return "بانک قرض الحسنه مهر ایران";
              } else if (newVal.startsWith("064")) {
                return "بانک گردشگری";
              } else if (newVal.startsWith("079")) {
                return "بانک مهر اقتصاد";
              } else if (newVal.startsWith("073")) {
                return "موسسه اعتباری کوثر";
              } else if (newVal.startsWith("020")) {
                return "بانک توصعه صادرات ایران";
              } else if (newVal.startsWith("078")) {
                return "بانک خاورمیانه";
              } else if (newVal.startsWith("095")) {
                return "بانک مشترک ایران - ونزوئلا";
              } else if (newVal.startsWith("075")) {
                return "موسسه اعتباری ملل";
              } else if (newVal.startsWith("080")) {
                return "موسسه اعتباری نور";
              } else {
                return null;
              }
            } else {
              return null;
            }
          },
        },
        {
          key: "trackingNumber",
          label: "کد رهگیری",
        },
      ],
      params1: [
        {
          label: "از تاریخ:",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateto",
          type: "date-picker",
        },
        {
          label: "نام مشتری:",
          field: "acceptor_code",
          type: "vselect",
          options: this.merchants,
        },
        {
          label: "بانک:",
          field: "bank_id",
          type: "mddropdown",
          group: 13,
        },
        {
          label: "کد رهگیری:",
          field: "trackingNumber",
          type: "text",
          group: 13,
        },
        {
          label: "مبلغ (ریال):",
          field: "amount",
          type: "number",
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {
    loadedUserList() {
      return this.$store.getters.loadedUserList;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارشات مالی",
        route: "merchants",
      },
      {
        title: "تراکنش ها",
      },
    ]);
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$store
        .dispatch(GET_USER_LIST, "users-with-transaction")
        .then((data) => {
          let option = [{ text: "انتخاب نشده", value: null }];
          data.forEach((element) => {
            option.push({ text: element.name, value: element.id });
          });

          this.params[2].options = option;
        });
    },
  },
};
</script>